"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactTracking = require("react-tracking");

var _stitches = require("../../stitches.config");

var _Button = require("../button/Button");

// import { handleOffline } from '../../utilities/offline';
var StyledLink = (0, _stitches.styled)('a', {
  marginLeft: '3px',
  marginRight: '3px',
  textAlign: 'center',
  color: '$textPrimary',
  textDecoration: 'underline',
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'none',
    color: '$textPrimary'
  },
  variants: {
    color: {
      black: {
        color: '$black'
      },
      blue: {
        color: '$blue'
      },
      white: {
        color: '$white'
      }
    },
    fontSize: {
      normal: {
        fontSize: '$normal'
      },
      small: {
        fontSize: '$small'
      },
      xSmall: {
        fontSize: '$xSmall'
      }
    },
    fontWeight: {
      medium: {
        fontWeight: '$medium'
      },
      semiBold: {
        fontWeight: '$semiBold'
      },
      bold: {
        fontWeight: '$bold'
      }
    },
    button: {
      primary: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _Button.baseButtonStyles), _Button.buttonStyles.variants.buttonShape.default), _Button.buttonStyles.variants.color.primary), {}, {
        display: 'block'
      }),
      secondary: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _Button.baseButtonStyles), _Button.buttonStyles.variants.buttonShape.default), _Button.buttonStyles.variants.color.secondary), {}, {
        display: 'block'
      })
    },
    textDecoration: {
      none: {
        textDecoration: 'none'
      },
      underline: {
        textDecoration: 'underline'
      }
    }
  }
});

var Link = function Link(_ref) {
  var activeClassName = _ref.activeClassName,
      activeStyle = _ref.activeStyle,
      button = _ref.button,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      exact = _ref.exact,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      id = _ref.id,
      linkType = _ref.linkType,
      onClick = _ref.onClick,
      name = _ref.name,
      newTab = _ref.newTab,
      path = _ref.path,
      strict = _ref.strict,
      textDecoration = _ref.textDecoration;

  var _useTracking = (0, _reactTracking.useTracking)(),
      trackEvent = _useTracking.trackEvent;

  var handleClick = function handleClick() {
    // if offline event.preventdefault() so the link doesnt go anywhere maybe? this is considered bad for ally/screen readers
    // maybe expose a prop that does something about it, or wrap the app context to both provide and handle
    // event.preventDefault();
    // console.log(event);
    trackEvent({
      event_name: "".concat(name, "-").concat(button ? 'button' : 'link'),
      event_type: 'click'
    });
    onClick(); // const ifOnline = () => {
    //   if (newTab) {
    //     window.open(href);
    //   } else {
    //     window.location.href = href;
    //   }
    // };
    // showModalIfOffline(ifOnline);
  };

  var additionalProps = {
    internal: {
      as: _reactRouterDom.Link,
      to: path
    },
    nav: {
      activeClassName: activeClassName,
      activeStyle: activeStyle,
      as: _reactRouterDom.NavLink,
      exact: exact,
      strict: strict,
      to: path
    },
    external: {
      href: path,
      role: 'link',
      tabIndex: '0',
      target: newTab ? '_blank' : '_self'
    }
  };
  return /*#__PURE__*/_react.default.createElement("span", {
    // eslint-disable-line jsx-a11y/click-events-have-key-events
    role: "link",
    tabIndex: path || !newTab ? undefined : 0,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(StyledLink, Object.assign({
    button: button,
    className: className,
    color: color,
    fontSize: fontSize,
    fontWeight: fontWeight,
    id: id,
    name: name,
    textDecoration: textDecoration
  }, additionalProps[linkType]), children));
};

Link.defaultProps = {
  activeClassName: 'selected',
  activeStyle: {},
  button: '',
  className: '',
  color: '',
  exact: false,
  fontSize: 'normal',
  fontWeight: '',
  id: '',
  linkType: 'internal',
  newTab: false,
  onClick: function onClick() {},
  path: undefined,
  strict: false,
  textDecoration: 'underline'
};
var _default = Link;
exports.default = _default;